import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");

export default class CorporateProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      profile: null,
      companyProfile: {},
      showUpdate: false,
      msg: "",
      toastColor: "",
    };
  }
  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let userId =
      this.props.id || params.get("id") || sessionStorage.getItem("userId");
    this.loadProfile(userId);
  }
  loadProfile(userId) {
    const token = sessionStorage.getItem("token");
    if (!token || !userId) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(API + `/users/${userId}/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const p = response.data || {};
        this.setState({
          loading: false,
          profile: p,
          companyProfile: p.companyProfile || {},
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load profile.",
          toastColor: "danger",
        });
      });
  }
  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    const company = s.companyProfile || {};
    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title={`Profile: ${s.profile?.fullName || "Corporate"}`} />
          {divMsg}
          <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center justify-content-center overflow-auto">
            <div className="w-100 mt-8 mb-2 h-100 overflow-auto" style={{ maxWidth: '48rem' }}>
              <div className="row g-4">
                <div className="d-flex flex-column gap-1 border-bottom pb-2">
                  <div className="fw-bold">Name</div>
                  <div>
                    {company.companyName || (
                      <span className="text-secondary">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Trading Name</div>
                  <div>
                    {company.tradingName || (
                      <span className="text-secondary">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Registration Number</div>
                  <div>
                    {company.registrationNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Physical Address</div>
                  <div>
                    {company.physicalAddress || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Primary Contact Firstname</div>
                  <div>
                    {company.primaryContactFirstName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Primary Contact Surname</div>
                  <div>
                    {company.primaryContactSurname || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Primary Contact Role</div>
                  <div>
                    {company.primaryContactRole || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                {!company.primaryContactPassportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="fw-bold">
                      Primary Contact National ID Number
                    </div>
                    <div>
                      {company.primaryContactIdNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                {company.primaryContactPassportNumber && (
                  <div className="flex flex-col gap-1 border-b pb-2">
                    <div className="fw-bold">
                      Primary Contact Passport Number
                    </div>
                    <div>
                      {company.primaryContactPassportNumber || (
                        <span className="text-gray-400">-</span>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Primary Contact Email</div>
                  <div>
                    {company.primaryContactEmail || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Primary Contact Number</div>
                  <div>
                    {company.primaryContactNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact Firstname</div>
                  <div>
                    {company.billingContactFirstName || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact Surname</div>
                  <div>
                    {company.billingContactSurname || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact Role</div>
                  <div>
                    {company.billingContactRole || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact National ID</div>
                  <div>
                    {company.billingContactIdNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact Email</div>
                  <div>
                    {company.billingContactEmail || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Billing Contact Number</div>
                  <div>
                    {company.billingContactNumber || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-1 border-b pb-2">
                  <div className="fw-bold">Company Type</div>
                  <div>
                    {company.companyType || (
                      <span className="text-gray-400">-</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center gap-8 mt-2">
              <button
                type="button"
                name="update"
                className="btn btn-primary"
                onClick={() => this.setState({ showUpdate: true })}
              >
                Update Profile
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => window.history.back()}
              >
                Cancel
              </button>
            </div>
          </div>
          
        </div>
      </div>
    );
  }
}
